var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EAEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9459 9.45659L22.0786 23.0342C21.8623 23.9924 21.2983 24.231 20.4966 23.7795L16.1278 20.5469L14.0199 22.5827C13.7866 22.817 13.5915 23.0128 13.142 23.0128L13.4558 18.5452L21.5527 11.1985C21.9048 10.8833 21.4763 10.7087 21.0055 11.0239L10.9958 17.3527L6.68643 15.9984C5.74906 15.7044 5.7321 15.0571 6.88153 14.6056L23.7371 8.0852C24.5174 7.79134 25.2003 8.25982 24.9459 9.45659Z",
    fill: "#2A5AFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTg);
export default __webpack_public_path__ + "static/media/icon-tg.df5939e0229a7559763811096df1a634.svg";
export { ForwardRef as ReactComponent };